















import { Component, Prop, Watch } from 'vue-property-decorator';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import { Funcionalidades } from '@/config/funcionalidades';

import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import {
  ColDef,
  ColumnApi,
  GridApi,
  GridOptions,
  GridReadyEvent,
  ICellRendererFunc,
  ICellRendererParams,
} from 'ag-grid-community';
import DetalleContrato from '@/pantallas/SucursalVirtual/Contratos/controllers/DetalleContratoController';
import { DatosContrato as TypeDatosContrato } from '@/pantallas/SucursalVirtual/Contratos/types';
import { actionsEvent } from '@/setup';

@Component({
  components: {
    MantenedorGridSinCodigo,
    MantenedorGrid,
  },
})
class ContratoGrillaArchivo extends ComponenteBase {
  @Prop({ required: true }) contratoId!: TypeDatosContrato['contratoId'];
  @Prop({ required: true }) recargarGrillaArchivo!: boolean;
  @Prop({ required: true }) esModoVerDetalle!: boolean;

  readonly funcionalidad = Funcionalidades.ContratoArchivo;
  readonly accionesTotales: PermisoAccion[] = [
    {
      accionCodigo: 5,
      visible: false,
    },
  ];

  columnApi: ColumnApi = null;
  gridOptions: GridOptions = null;
  gridApi: GridApi = null;
  usuarioID =
    String(JSON.parse(localStorage.getItem('user')).id.toString()) || '';
  clienteDefecto = localStorage.getItem('clienteDefecto') || '';
  email = String(JSON.parse(localStorage.getItem('user')).email) || '';
  archivos: any[] = [];

  @Watch('recargarGrillaArchivo')
  recargarGrillaArchivoFn() {
    if (this.recargarGrillaArchivo) {
      this.recargarGrilla();
    }
  }

  acciones() {
    actionsEvent.onEliminar(this.handleDesactivaArchivo);
  }

  constructor() {
    super();
    // Agregar acciones
    this.acciones();

    this.gridOptions = {
      columnDefs: this.columnasGrilla(),
      pagination: true,
      paginationPageSize: 3,
      cacheBlockSize: 3,
      onGridReady: this.handleGrillaLista,
    };
  }

  private columnasGrilla(): ColDef[] {
    const columnas = [
      { headerName: 'Contrato', field: 'url_pdf' },
      { headerName: 'Ver Archivo', field: 'icono_pdf' },
      { headerName: 'Tipo', field: 'tipo' },
      { headerName: 'Fecha Creación', field: 'fecha_creacion' },
    ];

    const columnasGrilla: ColDef[] = columnas.map(({ headerName, field }) => {
      let cellRenderer: ICellRendererFunc = null;

      if (field === 'url_pdf') {
        cellRenderer = ({ data }: ICellRendererParams) => {
          return data.url_pdf
            ? `<a href="${data.url_pdf}" target="_blank">${data.archivo_nombre}</a>`
            : '';
        };
      }

      if (field === 'icono_pdf') {
        cellRenderer = ({ data }: ICellRendererParams) => {
          return data.url_pdf
            ? `<a href="${data.url_pdf}" target="_blank" style="position: absolute; margin-top: 0%; margin-left: 3%; cursor: pointer;">
                <i class="material-icons" id="1356" style="cursor: pointer; color: rgb(39, 72, 142); font-size: 25px; padding-top: 5px;">download</i>
            </a>`
            : '';
        };
      }

      return {
        headerName,
        field,
        cellStyle: { textAlign: 'left' },
        resizable: true,
        minWidth: 100,
        cellRenderer,
      };
    });

    return columnasGrilla;
  }

  handleGrillaLista(e: GridReadyEvent) {
    this.gridApi = e.api;
    this.columnApi = e.columnApi;
  }

  async recargarGrilla() {
    if (!this.contratoId) return;
    this.archivos = await this.obtenerArchivosPorId();
    this.gridApi.setRowData(this.archivos);
    this.gridApi.setDomLayout('autoHeight');
  }

  async obtenerArchivosPorId() {
    this.loadingService.showLoading();
    try {
      const { archivos } = await DetalleContrato.obtenerArchivosPorId(
        this.contratoId
      );
      return archivos;
    } catch (e) {
      this.$snotify.error((e as Error).message);
    } finally {
      this.loadingService.hideLoading();
    }
  }

  async handleDesactivaArchivo({ data }: ICellRendererParams) {
    const { id_archivo } = data;
    if (!id_archivo) return;
    if (this.esModoVerDetalle) {
      this.$snotify.warning('No se puede eliminar en modo ver detalle.');
      return;
    }
    this.loadingService.showLoading();
    try {
      const { mensajeExito } = await DetalleContrato.desactivaArchivo(
        id_archivo,
        this.usuarioID,
        this.clienteDefecto
      );
      this.$snotify.success(mensajeExito);
      this.recargarGrilla();
    } catch (e) {
      this.$snotify.error((e as Error).message);
    } finally {
      this.loadingService.hideLoading();
    }
  }
}

export default ContratoGrillaArchivo;
